import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type Lightbulb04IconProps = IconProps

const Lightbulb04Icon = forwardRef<SVGSVGElement, Lightbulb04IconProps>(
  (props: Lightbulb04IconProps, ref) => (
    <Icon {...props} ref={ref}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9.5 22h5M10 10h4m-2 0v6m3-.674a7 7 0 1 0-6 0V16c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C10.602 19 11.068 19 12 19c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C15 17.398 15 16.932 15 16v-.674Z"
        fill="none"
      ></path>
    </Icon>
  ),
)

Lightbulb04Icon.displayName = 'Lightbulb04Icon'
Lightbulb04Icon.defaultProps = iconDefaultProps

export type { Lightbulb04IconProps }
export { Lightbulb04Icon }
